import { useTranslate } from "@similarweb/i18n-provider";
import { Info24px } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Tooltip } from "@similarweb/ui-components";
import { Flex, Text } from "@similarweb/ui-components/foundations";

import { GA_SECTION_TITLE, GA_SECTION_TITLE_TOOLTIP } from "./texts";

export const SectionTitle = () => {
    const { translate } = useTranslate();

    return (
        <Flex
            gap="4px"
            alignItems="center"
        >
            <Text
                fontVariant="subtitle1"
                color={colorsPalettes.carbon[400]}
            >
                {translate(GA_SECTION_TITLE)}
            </Text>
            <Tooltip content={translate(GA_SECTION_TITLE_TOOLTIP)}>
                <Info24px
                    size="sm"
                    color={colorsPalettes.carbon[200]}
                />
            </Tooltip>
        </Flex>
    );
};
